import { appCity } from "@l2r-front/l2r-app-city"
import { appDocument } from "@l2r-front/l2r-app-doc"
import { appRoad } from "@l2r-front/l2r-app-road"
import { appSafety } from "@l2r-front/l2r-app-safety"

import { I18N_NAMESPACE } from "./i18n"

export const l2rApps = {
    l2rServices: {
        index: 0,
        color: "cta-bg/cta-bg-primary",
        i18nNamespace: I18N_NAMESPACE,
        label: null,
        modules: {},
        path: "",
    },
    city: appCity,
    road: appRoad,
    safety: appSafety,
    document: appDocument,
}
